/* unplugin-vue-components disabled */import { render } from "./kunshan.vue?vue&type=template&id=990ca61a&scoped=true"
import script from "./kunshan.vue?vue&type=script&lang=js"
export * from "./kunshan.vue?vue&type=script&lang=js"

import "./kunshan.vue?vue&type=style&index=0&id=990ca61a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-990ca61a"]])

export default __exports__